import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _CATEGORIES$FILES$LAB;
import { CATEGORIES, FILES, LABELS } from './mutation-types';
export default (_CATEGORIES$FILES$LAB = {}, _defineProperty(_CATEGORIES$FILES$LAB, CATEGORIES, function (state, payload) {
  state[CATEGORIES] = payload;
}), _defineProperty(_CATEGORIES$FILES$LAB, FILES, function (state, payload) {
  state[FILES] = payload;
}), _defineProperty(_CATEGORIES$FILES$LAB, LABELS, function (state, payload) {
  state[LABELS] = payload;
}), _CATEGORIES$FILES$LAB);